import { render, staticRenderFns } from "./NotFoundView.vue?vue&type=template&id=1c344bb6&"
import script from "./NotFoundView.ts?vue&type=script&lang=ts&"
export * from "./NotFoundView.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports